import GetCanonicalRepresentationRequest from "src/model/GetCanonicalRepresentationRequest";
import CanonicalRepresentationAPIRequest from "src/model/CanonicalRepresentationAPIRequest";
import {
    HARDWARE_SOURCE_TO_AFFINITY_THRESHOLD_LIST_MAP,
    HARDWARE_SOURCE_TO_CANONICAL_SET_MAP
} from "../CIRepSearchForm/constant";

/**
 * The function is used to generate canonical representation api request body.
 */
export function generateCanonicalRepresentationRequestBody(inputData: GetCanonicalRepresentationRequest): CanonicalRepresentationAPIRequest[] {
    let requestBodies: CanonicalRepresentationAPIRequest[] = [];
    const hardwareSource = inputData.hardwareSource as keyof typeof HARDWARE_SOURCE_TO_CANONICAL_SET_MAP;
    const canonicalSet = HARDWARE_SOURCE_TO_CANONICAL_SET_MAP[hardwareSource];

    if (inputData.maxResults) {
        requestBodies.push({
            canonicalSet: canonicalSet,
            identifierType: inputData.itemIdType,
            itemId: [inputData.itemId],
            maxResults: inputData.maxResults
        });
    } else if (inputData.affinityThreshold === "ALL") {
        const affinityThresholdList = HARDWARE_SOURCE_TO_AFFINITY_THRESHOLD_LIST_MAP[hardwareSource]
        for (let affinityThreshold of affinityThresholdList) {
            requestBodies.push({
                canonicalSet: canonicalSet,
                identifierType: inputData.itemIdType,
                itemId: [inputData.itemId],
                affinityThreshold: affinityThreshold
            });
        }
    } else {
        requestBodies.push({
            canonicalSet: canonicalSet,
            identifierType: inputData.itemIdType,
            itemId: [inputData.itemId],
            affinityThreshold: parseFloat(inputData.affinityThreshold)
        });
    }
    return requestBodies;
}
